import { createConfig, fallback, http } from 'wagmi';
import { mainnet, sepolia, localhost, polygon } from 'wagmi/chains';
import { metaMask } from '@wagmi/connectors';

import * as chains from 'wagmi/chains';

const { APP_ENV } = process.env; // 环境参数

// 手动扩展 localhost 链的配置（解决默认配置可能不匹配的问题）
//   // 本地 合约地址
export const hardhatLocalhost = {
    ...localhost,
    id: 31337, // Hardhat 本地节点固定 ChainID
    name: 'Hardhat Localhost',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['http://127.0.0.1:8545'], // 明确指向本地 RPC 地址
            webSocket: ['ws://127.0.0.1:8545'],
        },
        public: {
            http: ['http://127.0.0.1:8545'],
        },
    },
};

//
const mapVcityNetwork = {
    development: {
        id: 20230826, // Hardhat 本地节点固定 ChainID
        name: 'Vcity network',
        nativeCurrency: {
            decimals: 18,
            name: 'Ether',
            symbol: 'ETH',
        },
        rpcUrls: {
            default: {
                http: ['https://testnet-rpc.vcity.app'], // 明确指向本地 RPC 地址
                webSocket: ['ws://testnet-rpc.vcity.app/ws'],
            },
            public: {
                http: ['https://testnet-rpc.vcity.app'],
            },
        },
    },
    production: {
        id: 20250825, // Hardhat 本地节点固定 ChainID
        name: 'Vcity network',
        nativeCurrency: {
            decimals: 18,
            name: 'Ether',
            symbol: 'ETH',
        },
        rpcUrls: {
            default: {
                http: ['https://mainnet-rpc.vcity.app'], // 明确指向本地 RPC 地址
                webSocket: ['ws://mainnet-rpc.vcity.app/ws'],
            },
            public: {
                http: ['https://mainnet-rpc.vcity.app'],
            },
        },
    },
    release: {
        id: 20230826, // Hardhat 本地节点固定 ChainID
        name: 'Vcity network',
        nativeCurrency: {
            decimals: 18,
            name: 'Ether',
            symbol: 'ETH',
        },
        rpcUrls: {
            default: {
                http: ['https://testnet-rpc.vcity.app'], // 明确指向本地 RPC 地址
                webSocket: ['ws://testnet-rpc.vcity.app/ws'],
            },
            public: {
                http: ['https://testnet-rpc.vcity.app'],
            },
        },
    },
    test: {
        id: 20230826, // Hardhat 本地节点固定 ChainID
        name: 'Vcity network',
        nativeCurrency: {
            decimals: 18,
            name: 'Ether',
            symbol: 'ETH',
        },
        rpcUrls: {
            default: {
                http: ['https://testnet-rpc.vcity.app'], // 明确指向本地 RPC 地址
                webSocket: ['ws://testnet-rpc.vcity.app/ws'],
            },
            public: {
                http: ['https://testnet-rpc.vcity.app'],
            },
        },
    },
};

// vcity 网络
export const vcityNetwork = {
    ...localhost,
    ...(mapVcityNetwork[APP_ENV] || {}),
};

// 充值网络
const mapRechargeNetwork = {
    development: {
        ...vcityNetwork,
    },

    production: {
        id: polygon.id, //
    },
    release: {
        ...vcityNetwork,
    },
    test: {
        ...vcityNetwork,
    },
};

export const rechargeNetwork = mapRechargeNetwork[APP_ENV] || {};
